export const HeadingType = {
    h1: 'bold pt-1 pb-1 font-black font-secondary',
    h2: 'bold pt-1 pb-1 font-black font-secondary',
    h3: 'bold pt-1 pb-1 font-black font-secondary',
    h4: 'bold pt-1 pb-1 font-black font-secondary ',
    h5: 'bold pt-1 pb-1 font-black font-secondary',
    h6: 'bold pt-1 pb-1 font-black font-secondary',
}
